// extracted by css-extract-rspack-plugin
export default {"form":"Form__form--btRxc"};